import { render, staticRenderFns } from "./Frequency.vue?vue&type=template&id=2a4556e0&scoped=true&"
import script from "./Frequency.vue?vue&type=script&lang=js&"
export * from "./Frequency.vue?vue&type=script&lang=js&"
import style0 from "./Frequency.vue?vue&type=style&index=0&id=2a4556e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4556e0",
  null
  
)

export default component.exports